import axios from 'axios';
import { readAccessToken } from '@/lib/auth';
import { getRuntimeConfig } from '@/runtimeConfig';

export const api = axios.create();

// baseURL is resolved per request rather than at module scope, because runtime configuration
// is only available after the bootstrap fetch has resolved.
api.interceptors.request.use((config) => {
  config.baseURL = getRuntimeConfig().apiUrl;

  const url = config.url ?? '';
  if (!url.startsWith('/public/')) {
    const token = readAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
});

export interface ApiProblem {
  status: number;
  message: string;
}

export function toProblem(error: unknown): ApiProblem {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { message?: unknown } | undefined;

    return {
      status: error.response?.status ?? 0,
      message:
        typeof data?.message === 'string'
          ? data.message
          : (error.message ?? 'The request failed.'),
    };
  }

  return { status: 0, message: 'The request failed.' };
}
